import { DebouncedFunction } from '../types';

export const debounce = <T>(func: (args: T) => void, wait = 0) => {
    let handle: number;

    const debounced = ((args: T) => {
        if (handle) {
            window.clearTimeout(handle);
        }

        handle = window.setTimeout(() => func(args), wait);
    }) as DebouncedFunction<T>;

    debounced.cancel = () => {
        window.clearTimeout(handle);
    };

    return debounced;
};
